export const ellipsis = (line: number = 1) => ({
  overflow: 'hidden',
  display: '-webkit-box',
  '-webkit-line-clamp': line,
  '-webkit-box-orient': 'vertical',
})
